import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { interval } from 'rxjs';
import { AuthService } from '@/shared/services';
import { Goal } from '@/core/interfaces';
import { environment } from '../../../../environments/environment';
import { ToolListService } from '@/shared/services/tool-list.service';
import { ActivatedRoute } from '@angular/router';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'about-pamlab',
  templateUrl: './about-pamlab.component.html',
  styleUrls: ['./about-pamlab.component.css'],
  standalone: false,
})
export class AboutPamlabComponent implements AfterViewInit, OnDestroy {
  public env = environment;
  public images = this.env['carousel_images'] as {
    path: string;
    name: string;
    description: string;
  }[];
  public currentPicIndex: number = 0;

  constructor(
    public authService: AuthService,
    public toolListService: ToolListService,
    private route: ActivatedRoute,
    private viewportScroller: ViewportScroller,
  ) {}

  ngAfterViewInit(): void {
    interval(10000).subscribe((x) => {
      this.updateImageIndex();
    });

    this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        this.viewportScroller.scrollToAnchor(fragment);
      }
    });
  }

  ngOnDestroy(): void {}

  updateImageIndex() {
    if (this.currentPicIndex === this.images.length - 1) {
      this.currentPicIndex = 0;
    } else {
      this.currentPicIndex++;
    }
  }

  shouldShowModuleBg(goalList: Goal[]) {
    for (const goal of goalList) {
      if (this.authService.hasPermission(goal.tool_permission)) {
        return true;
      }
    }

    return false;
  }
}
